export default "__VITE_ASSET__Dj12IT1Q__"